/**
 * @file login.jsx
 * @version 1.0.0
 * @description modulo para la iniciar sesión en el sistema.
 * @author Deiby A. Rodriguez R.
 * @contact deiby.rodriguez@correounivalle.edu.co
 * @date 28 de marzo de 2023
 */

import Login_component from "../../components/login/login_component";
import React from "react";

const Login = () => {
  return <Login_component />;
};

export default Login;
